<template>
  <IconLucideFolderDown />
</template>
